import React from "react";

import { SkeletonBox } from "~/components/skeleton/box";
import { cx } from "~/tools/class-variance";

import { IconDashboard } from "../../../components/icon";
import { Widget, type WidgetProps } from "../_widget";

export const DashboardEntry: React.FC<WidgetProps> = ({ className, children, ...props }) => (
	<Widget card role="button" {...props} className={cx("flex-row items-center text-13/[15px] text-grey-800", className)}>
		<SkeletonBox className="mr-3 shrink-0" el={IconDashboard} when={props.interactive ? true : undefined} />

		{children}
	</Widget>
);
